import { get } from "../../utils/BaseService";

export async function getAllTCSDetails(dispatch: any) {
   return await get(dispatch, '/tcs-details/getAllTCSDetails',null)
}